import React from 'react';
import { Result, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { HomeOutlined, ArrowLeftOutlined } from '@ant-design/icons';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f0f2f5',
      }}
    >
      <Result
        status="404"
        title="404"
        subTitle="Страница не найдена."
        extra={
          <Space>
            <Button size="middle" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
              Назад
            </Button>
            <Button size="middle" type="primary" icon={<HomeOutlined />} onClick={() => navigate('/app/search')}>
              На главную
            </Button>
          </Space>
        }
      />
    </div>
  );
}
